// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .skeleton-content {
  display: flex;
  flex-direction: column;
  border: 1.5px solid;
  border-radius: 10px;
  background: white;
}
:host .product-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
:host .amount-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
:host ion-skeleton-text {
  margin: 0;
  --border-radius: var(--radius-xl);
}
:host .title-skeleton {
  height: 24px;
  width: 60%;
}
:host .text-skeleton {
  height: 19px;
  width: 85%;
}
:host .total-skeleton {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-checkout/skeleton-checkout.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAAR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AAFR;AAKI;EACI,SAAA;EACA,iCAAA;AAHR;AAMI;EACI,YAAA;EACA,UAAA;AAJR;AAOI;EACI,YAAA;EACA,UAAA;AALR;AAQI;EACI,UAAA;AANR","sourcesContent":[":host {\r\n    .skeleton-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        border: 1.5px solid;\r\n        border-radius: 10px;\r\n        background: white;\r\n    }\r\n\r\n    .product-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        padding: 20px;\r\n    }\r\n\r\n    .amount-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        padding: 20px;\r\n    }\r\n\r\n    ion-skeleton-text {\r\n        margin: 0;\r\n        --border-radius: var(--radius-xl);\r\n    }\r\n\r\n    .title-skeleton {\r\n        height: 24px;\r\n        width: 60%;\r\n    }\r\n\r\n    .text-skeleton {\r\n        height: 19px;\r\n        width: 85%;\r\n    }\r\n\r\n    .total-skeleton {\r\n        width: 50%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
